import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { Role } from "../../../../service/roles-permission";

export interface EnrollmentData {
  _id: string;
  student: {
    _id: string;
    grNumber: string;
    dateOfBirth: string;
    motherTongue: string;
  };
  class: {
    _id: string;
    name: string;
  };
  section: {
    _id: string;
    name: string;
  };
  system: {
    _id: string;
    name: string;
  };
  branch: {
    _id: string;
    name: string;
  };
  session: {
    _id: string;
    name: string;
  };
  status: string;
}

export interface UserState {
  _id: string;
  email: string;
  role: Role;
  roleId?: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  address: string;
  isActive: boolean;
  branch: string;
  isBlocked: boolean;
  joiningDate: string;
  createdAt: string;
  updatedAt: string;
  lastLogin: string;
  token: string;
  permissions?: string[];
  isAuthenticated?: boolean;
  status?: string;
  employeeID?: string;
  enrollment?: EnrollmentData;
}

const initialState: UserState = {
  _id: "",
  email: "",
  role: {
    _id: "",
    name: "",
    permissions: [],
    isActive: false,
    createdAt: "",
    updatedAt: "",
  },
  roleId: "",
  firstName: "",
  lastName: "",
  phoneNumber: "",
  address: "",
  isActive: false,
  branch: "",
  isBlocked: false,
  joiningDate: "",
  createdAt: "",
  updatedAt: "",
  lastLogin: "",
  token: "",
  permissions: [],
  status: "inactive",
  employeeID: "",
  enrollment: undefined,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (_, { payload }: PayloadAction<UserState>) => {
      return {
        ...payload,
        permissions: payload.permissions,
        enrollment: payload.enrollment,
      };
    },

    resetUser: () => initialState,

    updatePermissions: (state, action: PayloadAction<string[]>) => {
      state.permissions = action.payload;
    },

    setEnrollment: (state, action: PayloadAction<EnrollmentData>) => {
      state.enrollment = action.payload;
    },

    updateEnrollment: (
      state,
      action: PayloadAction<Partial<EnrollmentData>>
    ) => {
      if (state.enrollment) {
        state.enrollment = { ...state.enrollment, ...action.payload };
      } else {
        state.enrollment = action.payload as EnrollmentData;
      }
    },

    clearEnrollment: (state) => {
      state.enrollment = undefined;
    },
  },
});

export const selectUser = (state: RootState): UserState => state.user;
export const selectUserPermissions = (state: RootState): string[] =>
  state.user.permissions || [];
export const selectIsAuthenticated = (state: RootState): boolean =>
  state.user.isAuthenticated || false;
export const selectUserEnrollment = (
  state: RootState
): EnrollmentData | undefined => state.user.enrollment;

export const {
  setUser,
  resetUser,
  updatePermissions,
  setEnrollment,
  updateEnrollment,
  clearEnrollment,
} = userSlice.actions;
export default userSlice.reducer;
